import { render, staticRenderFns } from "./Brand_Carousel.vue?vue&type=template&id=0278ee52&scoped=true"
import script from "./Brand_Carousel.vue?vue&type=script&lang=js"
export * from "./Brand_Carousel.vue?vue&type=script&lang=js"
import style0 from "./Brand_Carousel.vue?vue&type=style&index=0&id=0278ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0278ee52",
  null
  
)

export default component.exports